import React, { useContext } from "react";
// import styled from "styled-components";
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import { SettingsContext } from "../DataFactory/useSettings";
import { isFeatureEnabled } from "../services";

const useStyles = makeStyles((theme) => ({
  SettingRoute: {
    color: "#000",

    "& a": {
      color: "#000",
      cursor: "pointer",
      display: "block",
      padding: "6px 20px",
      fontSize: "13.5px",
      textDecoration: "none",
      fontWeight: "450",
      letterSpacing: "-0.2px",

      "&:hover": {
        color: "#FC4F56",
      },
    },
    "& a.active": {
      color: "#FC4F56",
    },
  },
}));
var headerStyle = {
  fontSize: "15px",
  margin: "0px",
  fontWeight: "550",
  padding: "0 20px",
  marginBottom: "10px",
};

var lineStyle = {
  width: "90%",
  marginTop: "10px",
  marginBottom: "15px",
  border: "0px",
  borderTop: "1px solid #eee",
};

export default function SettingRoutes(props) {
  const classes = useStyles();
  const { settings } = useContext(SettingsContext);

  // console.log(JSON.stringify(props));
  // export default function SettingView = ({ match }) => {
  return (
    <div className={classes.SettingRoute}>
      <br />
      <h3 style={headerStyle}>General Settings</h3>
      <Link
        to={{ pathname: "/settings/basic", state: "setting" }}
        className={props.url === "/settings/basic" ? "active" : ""}
      >
        Basic Settings
      </Link>
      <Link
        to={{
          pathname: "/settings/social",
          state: "setting",
        }}
        className={props.url === "/settings/social" ? "active" : ""}
      >
        Social Links
      </Link>
      <Link
        to={{
          pathname: "/settings/invoice",
          state: "setting",
        }}
        className={props.url === "/settings/invoice" ? "active" : ""}
      >
        Invoice Settings
      </Link>
     
      <hr style={lineStyle} />

      <h3 style={headerStyle}>User Settings</h3>
      <Link
        to={{
          pathname: "/settings/document-types/customer",
          state: "setting",
        }}
        className={props.url === "/settings/document-types" ? "active" : ""}
      >
        Document Types
      </Link>
      {(settings.signup_agent == true || settings.signup_vendor == true) && (
        <Link
          to={{
            pathname: "/settings/user-notifications/manager",
            state: "setting",
          }}
          className={
            props.url === "/settings/user-notifications" ? "active" : ""
          }
        >
          Notifications
        </Link>
      )}
      <Link
        to={{
          pathname: "/settings/app",
          state: "setting",
        }}
        className={props.url === "/settings/app" ? "active" : ""}
      >
        App Settings
      </Link>

      {isFeatureEnabled("subscriptions") && (
        <Link
          to={{
            pathname: "/settings/subscriptions",
            state: "setting",
          }}
          className={props.url === "/settings/subscriptions" ? "active" : ""}
        >
          Subscriptions
        </Link>
      )}
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Order Settings</h3>
      <Link
        to={{
          pathname: "/settings/order-notifications/customer",
          state: "setting",
        }}
        className={
          props.url === "/settings/order-notifications" ? "active" : ""
        }
      >
        Notifications{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/order-cancel-reasons/customer",
          state: "setting",
        }}
        className={
          props.url === "/settings/order-cancel-reasons" ? "active" : ""
        }
      >
        Cancel Reasons{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/other-settings",
          state: "setting",
        }}
        className={props.url === "/settings/other-settings" ? "active" : ""}
      >
        Other Settings
      </Link>

      <hr style={lineStyle} />

      <h3 style={headerStyle}>Delivery Settings</h3>
      {/* <Link
        to={{ pathname:"/settings/delivery-prefrences", state: 'setting' }}
        className={
          props.url === "/settings/delivery-prefrences" ? "active" : ""
        }
      >
        Delivery Prefrences
      </Link> */}
      {/* <Link
        to="{{ pathname:/settings/vehicle-types"
        className={props.url === "/settings/vehicle-types" ? "active" : ""}
      >
        Vehicle Types
      </Link> */}
      <Link
        to={{
          pathname: "/settings/assign-settings",
          state: "setting",
        }}
        className={props.url === "/settings/assign-settings" ? "active" : ""}
      >
        Assign Settings
      </Link>
      <Link
        to={{
          pathname: "/settings/pricing-rule",
          state: "setting",
        }}
        className={props.url === "/settings/pricing-rule" ? "active" : ""}
      >
        Pricing Rule
      </Link>
      <Link
        to={{
          pathname: "/settings/task-allocation",
          state: "setting",
        }}
        className={props.url === "/settings/task-allocation" ? "active" : ""}
      >
        Task Allocation
      </Link>
      <Link
        to={{
          pathname: "/settings/task-actions",
          state: "setting",
        }}
        className={props.url === "/settings/task-actions" ? "active" : ""}
      >
        Task Actions
      </Link>
      <Link
        to={{
          pathname: "/settings/task-notifications/customer/delivery",
          state: "setting",
        }}
        className={props.url === "/settings/task-notifications" ? "active" : ""}
      >
        Notifications
      </Link>
      {/* <Link
        to={{ pathname:"/settings/express-cost", state: 'setting' }}
        className={props.url === "/settings/express-cost" ? "active" : ""}
      >
        Express Cost
      </Link>
      <Link
        to={{ pathname:"/settings/driver-app", state: 'setting' }}
        className={props.url === "/settings/driver-app" ? "active" : ""}
      >
        Driver App
      </Link> */}
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Store Settings</h3>
      <Link
        to={{
          pathname: "/settings/events",
          state: "setting",
        }}
        className={props.url === "/settings/events" ? "active" : ""}
      >
        Events
      </Link>
      <Link
        to={{
          pathname: "/settings/timeslot-settings",
          state: "setting",
        }}
        className={props.url === "/settings/timeslot-settings" ? "active" : ""}
      >
        Timeslot Settings
      </Link>
      <Link
        to={{
          pathname: "/settings/timeslots/mon",
          state: "setting",
        }}
        className={props.url === "/settings/timeslots" ? "active" : ""}
      >
        Timeslots
      </Link>
      <Link
        to={{
          pathname: "/settings/tags/store",
          state: "setting",
        }}
        className={props.url === "/settings/tags" ? "active" : ""}
      >
        Tags
      </Link>
      {settings.brands_available == 1 && (
        <Link
          to={{
            pathname: "/settings/brands",
            state: "setting",
          }}
          className={props.url === "/settings/brands" ? "active" : ""}
        >
          Brands
        </Link>
      )}
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Product Settings</h3>
      <Link
        to={{
          pathname: "/settings/product-settings",
          state: "setting",
        }}
        className={props.url === "/settings/product-settings" ? "active" : ""}
      >
        Basic Settings
      </Link>
      <Link
        to={{
          pathname: "/settings/variant-types",
          state: "setting",
        }}
        className={props.url === "/settings/variant-types" ? "active" : ""}
      >
        Variant Types{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/bulk-upload",
          state: "setting",
        }}
        className={props.url === "/settings/bulk-upload" ? "active" : ""}
      >
        Bulk Upload{" "}
      </Link>
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Payment Settings</h3>
      <Link
        to={{
          pathname: "/settings/tax",
          state: "setting",
        }}
        className={props.url === "/settings/tax" ? "active" : ""}
      >
        Tax{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/wallet",
          state: "setting",
        }}
        className={props.url === "/settings/wallet" ? "active" : ""}
      >
        Wallet{" "}
      </Link>
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Content Settings</h3>
      <Link
        to={{
          pathname: "/settings/banners",
          state: "setting",
        }}
        className={props.url === "/settings/banners" ? "active" : ""}
      >
        Banners{" "}
      </Link>

      <Link
        to={{
          pathname: "/settings/faqs/customer",
          state: "setting",
        }}
        className={props.url === "/settings/faqs" ? "active" : ""}
      >
        FAQs{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/privacy-policy",
          state: "setting",
        }}
        className={props.url === "/settings/privacy-policy" ? "active" : ""}
      >
        Privacy Policy
      </Link>
      <Link
        to={{
          pathname: "/settings/terms-conditions",
          state: "setting",
        }}
        className={props.url === "/settings/terms-conditions" ? "active" : ""}
      >
        Terms & Conditions
      </Link>
      {isFeatureEnabled("popups") && (
        <Link
          to={{
            pathname: "/settings/offer-popups",
            state: "setting",
          }}
          className={props.url === "/settings/offer-popups" ? "active" : ""}
        >
          Offer Pop-Ups
        </Link>
      )}
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Website Settings</h3>
      <Link
        to={{ pathname: "/settings/website-settings", state: "setting" }}
        className={props.url === "/settings/website-settings" ? "active" : ""}
      >
        Basic Settings
      </Link>
      <Link
        to={{
          pathname: "/settings/web-banners",
          state: "setting",
        }}
        className={props.url === "/settings/web-banners" ? "active" : ""}
      >
        Web Banners{" "}
      </Link>

      <Link
        to={{ pathname: "/settings/web-plugin", state: "setting" }}
        className={props.url === "/settings/web-plugin" ? "active" : ""}
      >
        Homepage Plugins
      </Link>
      <Link
        to={{
          pathname: "/settings/web-seo-settings",
          state: "setting",
        }}
        className={props.url === "/settings/web-seo-settings" ? "active" : ""}
      >
        SEO Settings
      </Link>

      <hr style={lineStyle} />

      <h3 style={headerStyle}>Geo-location Settings</h3>

      <Link
        to={{
          pathname: "/settings/cities",
          state: "setting",
        }}
        className={props.url === "/settings/cities" ? "active" : ""}
      >
        Cities
      </Link>
      {/* <Link
        to={{ pathname: "/settings/geofence", state: 'setting' }}
        className={props.url === "/settings/geofence" ? "active" : ""}
      >
        Geofence
      </Link> */}
      <hr style={lineStyle} />

      <h3 style={headerStyle}>Notification Settings</h3>
      <Link
        to={{
          pathname: "/settings/email-notifications",
          state: "setting",
        }}
        className={
          props.url === "/settings/email-notifications" ? "active" : ""
        }
      >
        Email
      </Link>
      <Link
        to={{
          pathname: "/settings/sms-notifications",
          state: "setting",
        }}
        className={props.url === "/settings/sms-notifications" ? "active" : ""}
      >
        SMS{" "}
      </Link>
      <Link
        to={{
          pathname: "/settings/sms-otp-notifications",
          state: "setting",
        }}
        className={
          props.url === "/settings/sms-otp-notifications" ? "active" : ""
        }
      >
        SMS OTP
      </Link>

      <hr style={lineStyle} />

      <h3 style={headerStyle}>Staff Settings</h3>
      <Link
        to={{
          pathname: "/settings/roles",
          state: "setting",
        }}
        className={props.url === "/settings/roles" ? "active" : ""}
      >
        Roles
      </Link>
      <Link
        to={{
          pathname: "/settings/staff-members",
          state: "setting",
        }}
        className={props.url === "/settings/staff-members" ? "active" : ""}
      >
        Staff Members
      </Link>
      <Link
        to={{
          pathname: "/settings/branches",
          state: "setting",
        }}
        className={props.url === "/settings/branches" ? "active" : ""}
      >
        Branches
      </Link>
      <br />
    </div>
  );
}
